import(/* webpackMode: "eager", webpackExports: ["TermlyPolicy","PrivacyPolicyDataId"] */ "/codebuild/output/src3282395254/src/apps/wrap.gifts/src/services/Termly/TermlyPolicy.tsx");
